/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    TTLOOrderValue,
    TTLOOrderValueFromJSON,
    TTLOOrderValueFromJSONTyped,
    TTLOOrderValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLOQuery
 */
export interface TTLOQuery {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof TTLOQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof TTLOQuery
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof TTLOQuery
     */
    supplier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof TTLOQuery
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TTLOQuery
     */
    relevance?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOQuery
     */
    orderByDescending?: boolean;
    /**
     * 
     * @type {TTLOOrderValue}
     * @memberof TTLOQuery
     */
    orderValue?: TTLOOrderValue;
    /**
     * 
     * @type {number}
     * @memberof TTLOQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TTLOQuery
     */
    limit?: number | null;
}

export function TTLOQueryFromJSON(json: any): TTLOQuery {
    return TTLOQueryFromJSONTyped(json, false);
}

export function TTLOQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdCodeAndLabelFromJSON(json['supplier']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'orderByDescending': !exists(json, 'orderByDescending') ? undefined : json['orderByDescending'],
        'orderValue': !exists(json, 'orderValue') ? undefined : TTLOOrderValueFromJSON(json['orderValue']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function TTLOQueryToJSON(value?: TTLOQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'supplier': GuidIdCodeAndLabelToJSON(value.supplier),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'showDeleted': value.showDeleted,
        'showDisabled': value.showDisabled,
        'relevance': value.relevance,
        'orderByDescending': value.orderByDescending,
        'orderValue': TTLOOrderValueToJSON(value.orderValue),
        'offset': value.offset,
        'limit': value.limit,
    };
}


